<template>
    <div>
        <the-header>
            <template v-slot:title>
                {{ $route.meta.title }}
            </template>
            <template v-slot:search>
                <div class="search" ref="searchDiv">
                    <input
                            type="text"
                            v-model="searchText"
                            placeholder="Wyszukaj"
                            class="search__input"
                            autofocus
                            ref="searchInput"
                    />
                    <img
                            width="30px"
                            class="navbar__image"
                            src="@/assets/search.svg"
                            alt="search"
                            @click="search"
                    >
                    Wyszukaj
                </div>
            </template>
        </the-header>
        <section class="section">
            <div
                class="container"
                v-if="loadingStatus == 'loading'"
            >
                <div class="columns">
                    <div class="column has-text-centered">
                        <br />
                        <h1 class="title">Trwa pobieranie zamówienia</h1>
                        <svg-icon
                        class="svg svg-icon--background svg-icon__icon--loader"
                        type="return"
                        />
                    </div>
                </div>
            </div>
            <div
                class="container"
                v-else-if="loadingStatus == 'notFound'"
            >
                <div class="columns">
                    <div class="column has-text-centered">
                        <br />
                        <h1 class="title">Brak zamówień dla podanego ID</h1>
                        <svg-icon
                            class="svg svg-icon--background"
                            type="box"
                        />
                    </div>
                </div>
            </div>
            <div
                class="container"
                v-else-if="homeOrder"
            >
                <home-order :home-order="homeOrder" />
            </div>
            <div class="container" v-else>
                <div class="columns">
                    <div class="column has-text-centered">
                        <br />
                        <h1 class="title">Wyszukaj zamówienie</h1>
                        <svg-icon
                            class="svg svg-icon--background"
                            type="box"
                        />
                    </div>
                </div>
            </div>
        </section>
    </div>
</template>

<script>
import TheHeader from '@/components/TheHeader'
import HomeOrder from '@/components/HomeOrder'
import SvgIcon from '@/components/SvgIcon'

export default {
    name: 'HomeOrders',
    components: {
        'home-order': HomeOrder,
        'the-header': TheHeader,
        'svg-icon': SvgIcon
    },
    metaInfo: {
        title: 'Home Orders'
    },
    data(){
        return {
            showModal: true,
            searchText: ''
        }
    },
    computed: {
        loadingStatus(){
            return this.$store.getters.getHomeOrdersLoadingStatus
        },
        homeOrder(){
            return this.$store.getters.getHomeOrders
        },
        isNavbarHidden() {
            return this.$store.getters.isNavbarHidden
        }
    },
    methods: {
        search() {
            this.$store.dispatch('fetchHomeOrders', this.searchText)
        }
    }
}
</script>
<style lang="sass" scoped>
.section
    padding-bottom: 50vh
.search
    position: relative
    &__input
        position: absolute
        right: calc( 100% + 20px )
        height: 40px
        top: 0
        z-index: 1
        width: calc( 100vw - 220px )
        border: none
        border-bottom: 1px solid #69b200
        text-align: center
        transition: transform 600ms
        will-change: transform
        &::placeholder
            color: #69b200
            opacity: .8
</style>
